<div class="card-container">
    <div class="creative-panel">
        <img *ngIf="!data.isVideo" class="creative-image" [src]="data.creativeUrl" (error)="onCreativeError($event)" alt="">
        <ng-container *ngIf="data.isVideo">
            <video #videoEl class="creative-image" [src]="data.videoUrl" [poster]="data.creativeUrl"
                   [controls]="hasStarted()" preload="none" (play)="isPlaying.set(true); hasStarted.set(true)" (pause)="isPlaying.set(false)" (ended)="isPlaying.set(false)"></video>
            <img *ngIf="!isPlaying()" class="video-play-icon" (click)="videoEl.play()" [src]="'social-overview-assets/icons/videoPlayerIcon.svg' | assetVersion" alt="Play video">
        </ng-container>
    </div>

    <div class="info-panel">
        <div class="info-header">
            <div class="brand-logo">
                <img [src]="data.logoPath" (error)="onImageError($event)" alt="">
            </div>
            <div class="brand-meta">
                <span class="brand-name">{{ data.brandName }}</span>
                <app-social-platform-icons [platforms]="data.platforms" [iconSize]="14" [isVideo]="data.isVideo"></app-social-platform-icons>
            </div>
        </div>

        <div class="about">
            <div class="about-top">
                <div class="metric-boxes">
                    <div class="metric-box">
                        <span class="metric-label">Impressions</span>
                        <span class="metric-value">{{ data.impressions | shortNumber }}</span>
                    </div>
                    <div class="metric-box">
                        <span class="metric-label">CPM</span>
                        <span class="metric-value">${{ data.cpm }}</span>
                    </div>
                    <div class="metric-box metric-box--coming-soon">
                        <span class="metric-label">CTR</span>
                        <span class="metric-value blurred">0.48%</span>
                        <span class="coming-soon">Coming soon</span>
                    </div>
                </div>

                <div class="creative-text-cta">
                    <div class="creative-text">{{ data.description }}</div>
                    <div class="cta-row">
                        <a class="cta-button cta-primary" [attr.href]="data.ctaLink || null" target="_blank" rel="noopener">{{ data.ctaText }}</a>
                        <button class="cta-button cta-secondary" (click)="copyCtaLink()"><img class="cta-icon" width="14" height="14" [src]="'svg/copy-link.svg' | assetVersion" alt=""> Copy CTA link</button>
                    </div>
                </div>
            </div>

            <div class="chart-section">
                <span class="chart-label">Impressions</span>
                <app-performance-over-time class="impressions-chart" [data]="performanceData" [brandColors]="brandColors" format="shortNumber" [extraSettings]="chartExtraSettings"></app-performance-over-time>
            </div>

            <div class="details">
                <div class="details-col">
                    <div class="detail-row">
                        <span class="detail-label">First Seen</span>
                        <span class="detail-value">{{ data.firstSeen }}</span>
                    </div>
                    <div class="detail-row">
                        <span class="detail-label">Last Seen</span>
                        <span class="detail-value">{{ data.lastSeen }}</span>
                    </div>
                </div>
                <div class="details-col">
                    <div class="detail-row">
                        <span class="detail-label">Ad type</span>
                        <span class="detail-value">{{ formattedAdType }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <button class="close-button" (click)="close()" aria-label="Close">
        <img [src]="'svg/closeX.svg' | assetVersion" alt="">
    </button>
</div>
